"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommunityPoolInvitationStatusToJSON = exports.CommunityPoolInvitationStatusFromJSONTyped = exports.CommunityPoolInvitationStatusFromJSON = exports.CommunityPoolInvitationStatus = void 0;
/**
 *
 * @export
 * @enum {string}
 */
var CommunityPoolInvitationStatus;
(function (CommunityPoolInvitationStatus) {
    CommunityPoolInvitationStatus["INVITED"] = "INVITED";
    CommunityPoolInvitationStatus["ACCEPTED"] = "ACCEPTED";
    CommunityPoolInvitationStatus["DECLINED"] = "DECLINED";
})(CommunityPoolInvitationStatus = exports.CommunityPoolInvitationStatus || (exports.CommunityPoolInvitationStatus = {}));
function CommunityPoolInvitationStatusFromJSON(json) {
    return CommunityPoolInvitationStatusFromJSONTyped(json, false);
}
exports.CommunityPoolInvitationStatusFromJSON = CommunityPoolInvitationStatusFromJSON;
function CommunityPoolInvitationStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.CommunityPoolInvitationStatusFromJSONTyped = CommunityPoolInvitationStatusFromJSONTyped;
function CommunityPoolInvitationStatusToJSON(value) {
    return value;
}
exports.CommunityPoolInvitationStatusToJSON = CommunityPoolInvitationStatusToJSON;
